<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { navigate } from 'svelte-routing';
  import { FileQuestion, Home, ArrowLeft } from 'lucide-svelte';
  import { Button } from '../lib/components/ui/index';
</script>

<div class="flex flex-col items-center justify-center py-20 px-4 text-center">
  <div class="mb-6 p-6 bg-accent/10 rounded-full">
    <FileQuestion class="w-16 h-16 text-accent" strokeWidth={1.5} />
  </div>

  <h1 class="text-3xl font-semibold text-text mb-2">
    {$_('pages.error.not_found_title')}
  </h1>

  <p class="text-text-secondary mb-8 max-w-md mx-auto">
    {$_('pages.error.not_found_message')}
  </p>

  <div class="flex gap-3">
    <Button variant="primary" on:click={() => navigate('/')}>
      <Home class="w-4 h-4" strokeWidth={1.5} />
      {$_('nav.dashboard')}
    </Button>
    <Button variant="secondary" on:click={() => window.history.back()}>
      <ArrowLeft class="w-4 h-4" strokeWidth={1.5} />
      {$_('nav.back')}
    </Button>
  </div>
</div>
